import { Controller, UseControllerProps, FieldValues } from 'react-hook-form'

import { AnimatedTextInput } from '../../AnimatedTextInput'
import { AnimatedTextInputProps } from '../../AnimatedTextInput/types'

export function TextInputForm<FormTypes extends FieldValues>({
  control,
  name,
  rules,
  ...textInputProps
}: AnimatedTextInputProps & UseControllerProps<FormTypes>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <AnimatedTextInput
          value={field.value}
          onChangeText={field.onChange}
          errorMessage={fieldState.error?.message}
          className="ym-hide-content"
          ref={field.ref}
          {...textInputProps}
        />
      )}
    />
  )
}
